import styled from "styled-components";
import { Colors } from "~/config/Colors";

export const Container = styled.div`
  width: calc(100% - 0rem);
  height: 100%;
  padding: 1rem 1rem;
  background: ${Colors.Color13};
  border-radius: 0.5rem;

  .subMenu-button {
    margin-bottom: 0.5rem;
  }
`;
